module.exports = __webpack_public_path__ + "img/Ancho_Tips.90002408.png";